import {
  CircularProgress,
  IconButton,
  Table,
  Typography,
} from "@material-ui/core";
import HomeHeaderMenu from "../../../../Components/HeaderMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useParams } from "react-router";
import { useEffect, useState } from "react";
import DebouncedInput from "./LiveView/TableComponents/DebouncedInput";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFacetedRowModel,
  getFilteredRowModel,
  getFacetedUniqueValues,
  getPaginationRowModel,
} from "@tanstack/react-table";
import TableHeader from "./LiveView/TableHeader";
import TableFooterCustom from "./LiveView/TableFooterCustom";
import TableBodyCustom from "./LiveView/TableBodyCustom";
import ScrollToPopup from "./LiveView/TableComponents/ScrollToPopup";
import useColumnsDataDefiner from "./LiveView/Hooks/useColumnsDataDefiner";
import Refresh from "@material-ui/icons/Refresh";
import useGlobalSearch from "./LiveView/Hooks/useGlobalSearch";
import { Search } from "@material-ui/icons";

let i = 0;

const LiveView = () => {
  const history = useHistory();

  const setupObj = {
    organisation: {
      liveViewFor: "Organization",
      fetchApi: "organisations/live_organisation_list_data",
      updateApiKey: "liveViewOrganisation",
    },
    partner: {
      liveViewFor: "Partner",
      fetchApi: "partner_profiles/live_partner_profile_list_data",
      updateApiKey: "liveViewPartner",
    },
  };
  const params = useParams();
  const { liveViewFor, fetchApi, updateApiKey } = setupObj[params.type];
  const liveViewType = params.type;

  const {
    columns,
    activeData,
    setActiveData,
    isDataLoading,
    refetchData,
    isRefetching,
  } = useColumnsDataDefiner(fetchApi, params.type);

  const [globalFilter, setGlobalFilter] = useState("");
  const [editRowIndex, setEditRowIndex] = useState(null);
  const {
    searchLoading: globalSearchLoading,
    filteredRows,
    filterOutFunction,
  } = useGlobalSearch(columns, activeData, globalFilter);

  const table = useReactTable({
    columns,
    state: {
      editRowIndex,
      setEditRowIndex,
      activeData,
      setActiveData,
      liveViewType,
      fetchApi,
      updateApiKey,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    onEditRowIndex: editRowIndex,
    data: activeData,
    enablePinning: true,
    getCoreRowModel: getCoreRowModel(),
    enableColumnResizing: false,
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getPaginationRowModel: getPaginationRowModel(),

    enableColumnFilters: true,
    enableFilters: true,
    autoResetPageIndex: true,
    filterFns: {
      filterOut: filterOutFunction,
    },
    enableMultiRowSelection: false,
  });

  return (
    <>
      <HomeHeaderMenu />
      <div
        style={{
          padding: " 0.5rem 2rem 0px 2rem ",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            width: "100%",
            marginBottom: "0.75rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant='h1' style={{ color: "#077f83" }}>
              {liveViewFor} Live View
            </Typography>
          </div>
          <div
            style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
          >
            <DebouncedInput
              value={globalFilter ?? ""}
              onChange={(value) => setGlobalFilter(String(value))}
              placeholder='Search all columns...'
              endAdornment={
                globalSearchLoading ? (
                  <CircularProgress size={30} color='secondary' />
                ) : (
                  <Search fontSize='20px' color='secondary' />
                )
              }
            />
            <ScrollToPopup table={table} />
            <div>
              {isRefetching ? (
                <CircularProgress color='secondary' size={20} />
              ) : (
                <IconButton onClick={refetchData}>
                  <Refresh color='secondary' fontSize='20px' />
                </IconButton>
              )}
            </div>
          </div>
        </div>

        {isDataLoading ? (
          <div
            style={{
              width: "100%",
              height: "530px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "10px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              overflowX: "scroll",
              height: "530px",
              boxShadow: "0px 0px 10px #aaa",
              borderRadius: "3px",
              marginBottom: "10px",
            }}
          >
            <Table
              style={{
                width: "100%",
              }}
              stickyHeader
              className='main-table-live-view'
            >
              <TableHeader table={table} />
              <TableBodyCustom filteredRows={filteredRows} table={table} />
            </Table>
          </div>
        )}
        <TableFooterCustom
          table={table}
          filteredRows={filteredRows}
          globalFilter={globalFilter}
        />
      </div>
    </>
  );
};

export default LiveView;
